var map = {
	"./confetti.png": 2314,
	"./modal-bg.png": 2315,
	"./notice.jpg": 2316,
	"./premier-league-bg.png": 2317,
	"./reward-1.png": 2318,
	"./reward-2.png": 2319,
	"./reward-3.png": 2320,
	"./reward-4.png": 2321,
	"./reward-6.png": 2322,
	"./reward-9.png": 2323,
	"./versus.png": 2324,
	"./white-button-active.png": 2325,
	"./white-button-inactive.png": 2326,
	"./win-2.png": 2327,
	"./win.png": 2328,
	"./world-cup-vs-bg-mobile.jpg": 2329,
	"./world-cup-vs-bg.jpg": 2330,
	"./入场劵.jpg": 2331
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 171;